import React, { useState } from 'react';
import { ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
interface Position {
  position_id: string;
  opened: string;
  side: 'Long' | 'Short';
  pair: string;
  opening_price: number;
  quantity: number;
  closing_price: number;
  pnl_abs: number;
  pnl_pct: number;
}
const mockPositionsData: Position[] = [{
  position_id: 'T5SYTM',
  opened: '1/15/26 11:35 PM',
  side: 'Long',
  pair: 'BTC/USD',
  opening_price: 95790.6,
  quantity: 0.15,
  closing_price: 95078.1,
  pnl_abs: -106.88,
  pnl_pct: -0.74
}, {
  position_id: 'T6GVOW',
  opened: '12/11/25 10:31 PM',
  side: 'Long',
  pair: 'BTC/USD',
  opening_price: 93487.8,
  quantity: 0.25,
  closing_price: 91772.5,
  pnl_abs: -428.82,
  pnl_pct: -1.83
}, {
  position_id: 'TNCSIW',
  opened: '12/8/25 11:32 PM',
  side: 'Short',
  pair: 'ETH/USD',
  opening_price: 3450.5,
  quantity: 2.5,
  closing_price: 3380.2,
  pnl_abs: 175.75,
  pnl_pct: 2.04
}, {
  position_id: 'T7EEXN',
  opened: '6/16/19 6:07 PM',
  side: 'Long',
  pair: 'SOL/USD',
  opening_price: 138.5,
  quantity: 50,
  closing_price: 142.2,
  pnl_abs: 185.0,
  pnl_pct: 2.67
}, {
  position_id: 'TCMHZ5',
  opened: '6/16/19 6:07 PM',
  side: 'Long',
  pair: 'BTC/USD',
  opening_price: 96200.0,
  quantity: 0.05,
  closing_price: 9261.1,
  pnl_abs: -175.83,
  pnl_pct: -3.73
}];
// Helper to get icon URL
const getIconUrl = (pair: string) => {
  const symbol = pair.split('/')[0].toLowerCase();
  const map: Record<string, string> = {
    btc: 'bitcoin-btc',
    eth: 'ethereum-eth',
    sol: 'solana-sol',
    usdt: 'tether-usdt',
    bnb: 'bnb-bnb',
    xrp: 'xrp-xrp',
    ada: 'cardano-ada',
    doge: 'dogecoin-doge'
  };
  const slug = map[symbol] || `${symbol}-${symbol}`;
  return `https://cryptologos.cc/logos/${slug}-logo.svg`;
};
export function PositionsTab() {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const clearFilters = () => {
    setDateFrom('');
    setDateTo('');
  };
  const hasActiveFilters = dateFrom || dateTo;
  // Filter logic (simplified for mock data)
  const filteredData = mockPositionsData.filter(position => {
    // Date filtering would go here
    return true;
  });
  const totalItems = filteredData.length;
  const itemsPerPage = 25;
  const currentPage = 1;
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
  return <div className="space-y-4" data-id="element-163">
      {/* Filters */}
      <div className="bg-background-secondary border border-border-subtle rounded-xl p-4" data-id="element-164">
        <div className="flex items-center gap-3 flex-wrap" data-id="element-165">
          {/* Date Range */}
          <div className="flex items-center gap-2" data-id="element-166">
            <span className="text-sm text-text-secondary" data-id="element-167">Date</span>
            <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} placeholder="From" className="px-4 py-2 bg-background-elevated text-text-primary rounded-lg text-sm border border-border-subtle focus:border-border-default outline-none" data-id="element-168" />
            <span className="text-text-secondary" data-id="element-169">to</span>
            <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} placeholder="To" className="px-4 py-2 bg-background-elevated text-text-primary rounded-lg text-sm border border-border-subtle focus:border-border-default outline-none" data-id="element-170" />
          </div>

          {/* Clear Filters */}
          {hasActiveFilters && <button onClick={clearFilters} className="flex items-center gap-2 px-4 py-2 text-text-secondary hover:text-text-primary transition-colors text-sm" data-id="element-171">
              Clear filters
            </button>}
        </div>
      </div>

      {/* Table */}
      <div className="bg-background-secondary border border-border-subtle rounded-xl overflow-hidden" data-id="element-172">
        <div className="overflow-x-auto" data-id="element-173">
          <table className="w-full" data-id="element-174">
            <thead className="bg-background-elevated/50" data-id="element-175">
              <tr className="border-b border-border-subtle" data-id="element-176">
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-left" data-id="element-177">
                  Position Opened
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-left" data-id="element-178">
                  Side
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-left" data-id="element-179">
                  Pair
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-180">
                  Opening Price
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-181">
                  Quantity
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-182">
                  Closing Price
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-183">
                  P&L
                </th>
                <th className="px-6 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-184">
                  ID
                </th>
              </tr>
            </thead>
            <tbody data-id="element-185">
              {filteredData.map(position => <tr key={position.position_id} className="border-b border-border-subtle hover:bg-background-elevated/30 transition-colors" data-id="element-186">
                  <td className="px-6 py-4 text-sm text-text-primary" data-id="element-187">
                    {position.opened}
                  </td>
                  <td className="px-6 py-4 text-sm text-text-primary" data-id="element-188">
                    <span className={`px-2 py-1 rounded text-xs font-medium ${position.side === 'Long' ? 'bg-success/10 text-success' : 'bg-danger/10 text-danger'}`} data-id="element-189">
                      {position.side}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-190">
                    <div className="flex items-center gap-2" data-id="element-191">
                      <img src={getIconUrl(position.pair)} alt={position.pair} className="w-5 h-5 object-contain" data-id="element-192" />
                      <span className="text-sm font-medium text-text-primary" data-id="element-193">
                        {position.pair}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-194">
                    <div className="font-numbers text-sm text-text-primary" data-id="element-195">
                      {position.opening_price.toLocaleString('en-US', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                  })}
                      <span className="text-text-secondary text-xs ml-1" data-id="element-196">
                        USD
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-197">
                    <div className="font-numbers text-sm text-text-primary" data-id="element-198">
                      {position.quantity.toFixed(4)}
                      <span className="text-text-secondary text-xs ml-1" data-id="element-199">
                        {position.pair.split('/')[0]}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-200">
                    <div className="font-numbers text-sm text-text-primary" data-id="element-201">
                      {position.closing_price.toLocaleString('en-US', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                  })}
                      <span className="text-text-secondary text-xs ml-1" data-id="element-202">
                        USD
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-203">
                    <div className={`font-numbers text-sm ${position.pnl_abs >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-204">
                      {position.pnl_abs >= 0 ? '+' : ''}
                      {position.pnl_abs.toFixed(2)}
                      <span className="text-text-secondary text-xs ml-1" data-id="element-205">
                        USD
                      </span>
                    </div>
                    <div className={`font-numbers text-xs ${position.pnl_pct >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-206">
                      {position.pnl_pct >= 0 ? '+' : ''}
                      {position.pnl_pct.toFixed(2)}%
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-207">
                    <div className="font-numbers text-xs text-text-secondary" data-id="element-208">
                      {position.position_id}
                    </div>
                  </td>
                </tr>)}
              {filteredData.length === 0 && <tr data-id="element-209">
                  <td colSpan={8} className="px-6 py-8 text-center text-text-secondary" data-id="element-210">
                    No positions found matching your filters.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="px-6 py-4 border-t border-border-subtle flex items-center justify-between" data-id="element-211">
          <div className="text-sm text-text-secondary" data-id="element-212">
            {totalItems > 0 ? `1 - ${Math.min(itemsPerPage, totalItems)} of ${totalItems}` : '0 of 0'}
          </div>
          <div className="flex items-center gap-2" data-id="element-213">
            <button disabled={currentPage === 1} className="p-2 text-text-secondary hover:text-text-primary hover:bg-background-elevated rounded-lg transition-all disabled:opacity-50 disabled:hover:bg-transparent" data-id="element-214">
              <ChevronLeft size={16} data-id="element-215" />
            </button>
            <div className="text-sm font-medium text-text-primary px-2" data-id="element-216">
              Page {currentPage} of {totalPages}
            </div>
            <button disabled={currentPage === totalPages} className="p-2 text-text-secondary hover:text-text-primary hover:bg-background-elevated rounded-lg transition-all disabled:opacity-50 disabled:hover:bg-transparent" data-id="element-217">
              <ChevronRight size={16} data-id="element-218" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}